import { render } from "./addTenant.vue?vue&type=template&id=67d029db&scoped=true"
import script from "./addTenant.vue?vue&type=script&lang=js"
export * from "./addTenant.vue?vue&type=script&lang=js"

import "./addTenant.vue?vue&type=style&index=0&id=67d029db&scoped=true&lang=css"

import exportComponent from "/mnt/extra-storage/rentalkenya_vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67d029db"]])

export default __exports__